export { default } from "./ListCategorias";
